
import { getSelectedBursts, removeBurst } from "@/helpers/store";
import { defineComponent, reactive, toRefs } from "vue";
import VueFeather from "vue-feather";
import BurstItem from "@/components/BurstItem.vue";

export default defineComponent({
  components: {
    VueFeather,
    BurstItem,
  },
  setup() {
    const state = reactive({
      selectedPages: getSelectedBursts(),
    });

    const removeAllBursts = () => {
      state.selectedPages.map((burst) => removeBurst(burst));
    };

    return {
      ...toRefs(state),
      getSelectedBursts,
      removeBurst,
      removeAllBursts,
    };
  },
});
